import { Stack, Typography } from "@mui/material";
import { CountryFlag } from "../../../../../../common/CountryFlag";

type LabelTextProps = {
	label: string;
	value?: string | number | null;
	countryCode?: string | null;
	textBold?: boolean;
};

export const LabelText = ({ label, value, countryCode, textBold }: LabelTextProps) => {
	return (
		<Stack direction={"row"} spacing={2} justifyContent={"space-between"}>
			<Typography flex={1.2} variant="subtitle2" fontWeight={400} color={"text.secondary"}>
				{label}
			</Typography>

			<Stack flex={2} direction={"row"} alignItems={"center"} spacing={1}>
				{countryCode ? (
					<>
						<CountryFlag countryCode={countryCode} width={20} height={18} />
						<Typography variant="body2" fontWeight={textBold ? 700 : 400}>
							{value || "-"}
						</Typography>
					</>
				) : (
					<Typography variant="body2" fontWeight={textBold ? 700 : 400}>
						{value || "-"}
					</Typography>
				)}
			</Stack>
		</Stack>
	);
};
